import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';

import { getCurrentIsoDateWithoutTime } from '@app/shared/misc/dates';
import { BenefitsDto, LevelsDto, PartnerFirm, PropertiesDto, SaveFirmDto } from '../state/types/partner.types';
import { BLService } from './bl.service';

@Injectable({ providedIn: 'root' })
export class PartnerProgramService extends BLService {
  private RESOURCE_ENDPOINT = 'partner-program';

  getFirm(language = 'sv', startDate = getCurrentIsoDateWithoutTime()): Observable<PartnerFirm> {
    return this.httpGet<PartnerFirm>(`${this.RESOURCE_ENDPOINT}/firm?language=${language}&startDate=${startDate}`).pipe(
      catchError((err: any) => {
        if (err.status === 404 && err.error.message === 'PARTNER_NO_PARTNER_DATA') {
          return of(null);
        }

        return throwError(() => err);
      }),
    );
  }

  getBenefits(language = 'sv'): Observable<BenefitsDto> {
    return this.httpGet<BenefitsDto>(`${this.RESOURCE_ENDPOINT}/benefits?language=${language}`);
  }

  getProperties(language = 'sv'): Observable<PropertiesDto> {
    return this.httpGet<PropertiesDto>(`${this.RESOURCE_ENDPOINT}/properties?language=${language}`);
  }

  getLevels(language = 'sv'): Observable<LevelsDto> {
    return this.httpGet<LevelsDto>(`${this.RESOURCE_ENDPOINT}/levels?language=${language}`);
  }

  updateFirm(data: SaveFirmDto): Observable<SaveFirmDto> {
    return this.httpPost<SaveFirmDto>(`${this.RESOURCE_ENDPOINT}/firm`, data);
  }
}
